import React from 'react';
import { Chip, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import i18next from 'i18next';

type CacheDebugSource = {
  name: string;
  key: string;
  type: string;
  source: string;
  inRedis: boolean;
  redisTtlSeconds?: number | null;
  inDb?: boolean | null;
  dbUpdatedAt?: string | null;
};

const formatTtl = (seconds?: number | null) => {
  if (seconds === null || seconds === undefined) return '–';
  if (seconds < 0) return String(i18next.t('system-storage-no-ttl'));
  if (seconds >= 3600) return `${Math.floor(seconds / 3600)} h ${Math.floor((seconds % 3600) / 60)} min`;
  if (seconds >= 60) return `${Math.floor(seconds / 60)} min`;
  return `${seconds} s`;
};

const SOURCE_COLORS: Record<string, 'success' | 'info' | 'default'> = {
  REDIS: 'success',
  DB: 'info',
  NONE: 'default',
};

/** Per value of the cache debug tool: where it was read from, Redis TTL and DB timestamp. */
export const CacheDebugSourcesTable = ({ sources }: { sources: CacheDebugSource[] }) => (
  <Table size="small" sx={{ mb: 2 }}>
    <TableHead>
      <TableRow>
        <TableCell>Key</TableCell>
        <TableCell>{i18next.t('system-storage-source')}</TableCell>
        <TableCell>{i18next.t('system-storage-in-redis')}</TableCell>
        <TableCell>{i18next.t('system-storage-in-db')}</TableCell>
        <TableCell>{i18next.t('system-storage-db-updated')}</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {sources.map(s => (
        <TableRow key={s.key}>
          <TableCell sx={{ fontFamily: 'monospace' }}>{s.key}</TableCell>
          <TableCell>
            <Chip label={String(i18next.t(`system-storage-source-${s.source}`))} color={SOURCE_COLORS[s.source] ?? 'default'} size="small" />
          </TableCell>
          <TableCell>{s.inRedis ? `✓ (${formatTtl(s.redisTtlSeconds)})` : '–'}</TableCell>
          <TableCell>{s.inDb === null || s.inDb === undefined ? String(i18next.t('system-storage-not-db-backed')) : s.inDb ? '✓' : '–'}</TableCell>
          <TableCell>{s.dbUpdatedAt ? new Date(s.dbUpdatedAt).toLocaleString() : '–'}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
